import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0bf873c4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "text-content"
};
const _hoisted_2 = {
  class: "ellipsis ellipsis-3"
};
const _hoisted_3 = {
  class: "status-item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_wrap_with_copy = _resolveComponent("wrap-with-copy");
  const _component_app_popover = _resolveComponent("app-popover");
  const _component_wrap_with_status_icon = _resolveComponent("wrap-with-status-icon");
  const _component_app_td = _resolveComponent("app-td");
  return _openBlock(), _createBlock(_component_app_td, {
    class: "border-table-row description-background-cell"
  }, {
    default: _withCtx(() => [_createVNode(_component_wrap_with_status_icon, {
      validationStatus: $props.item.product_description_style.validationStatus,
      status: $props.item.product_description_style.status,
      id: $props.uid
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        ref: $props.uid,
        class: _normalizeClass(['content-box', 'is-hovering', {
          'copying-hovered': _ctx.is_copying,
          'is-copied': $data.isClicked && _ctx.is_copying
        }]),
        onClick: _cache[0] || (_cache[0] = $event => !this.is_copying ? _ctx.$emit('onEdit', {
          item: $props.item,
          type: 'product_description',
          title: 'Description'
        }) : _ctx.$emit('onPaste', {
          item: $props.item,
          type: 'product_description',
          title: 'Description'
        }))
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("p", {
        style: _normalizeStyle($props.item.product_description_style.style)
      }, [$props.item.product_description !== null && typeof $props.item.product_description !== 'undefined' && $props.item.product_description.trim() != '' ? (_openBlock(), _createBlock(_component_wrap_with_copy, {
        key: 0,
        onCopied: $options.handleCopied
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_2, _toDisplayString($props.item.product_description), 1)]),
        _: 1
      }, 8, ["onCopied"])) : _createCommentVNode("", true)], 4), $props.item.product_description_style.status != 'unknown' && $props.index == 0 ? (_openBlock(), _createBlock(_component_app_popover, {
        key: 0,
        target: $props.uid,
        "auto-width": "",
        placement: "top",
        "custom-class": `${$props.item.product_description_style.status} ${!$props.showPopover ? 'hide-popover' : ''}`
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString($props.item.product_description_style.tooltipText), 1)])]),
        _: 1
      }, 8, ["target", "custom-class"])) : _createCommentVNode("", true), !$props.item.sku ? (_openBlock(), _createBlock(_component_app_popover, {
        key: 1,
        target: $props.uid,
        "auto-width": "",
        placement: "top",
        "custom-class": `not-editable ${!$props.showPopover ? 'hide-popover' : ''}`
      }, {
        default: _withCtx(() => [_createTextVNode(" Assign SKU to the item to start editing the content ")]),
        _: 1
      }, 8, ["target", "custom-class"])) : _createCommentVNode("", true)])], 2)]),
      _: 1
    }, 8, ["validationStatus", "status", "id"])]),
    _: 1
  });
}